module.exports = __webpack_public_path__ + "img/m1-screenshot-07_t.4e36c7da.jpg";